.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: white;
}

.containerHeader {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.printButton {
  padding: "5rem";
  float: right;
  margin-left: 20px;
}

.containerBody {
  border-collapse: collapse;
}

.containerBody::after {
  display: " ";
  clear: both;
}

.generatedQrComponent {
  padding: 2em;
  width: 100%;
  border-collapse: collapse;
  vertical-align: bottom;
}

.showCuttingLines .generatedQrComponent {
  border: 2px dashed gray;
}

.elemsInRow_1 td {
  font-size: 1.2em;
  width: 100%;
}

.elemsInRow_2 td {
  font-size: 1em;
  width: 50%;
}

.elemsInRow_3 td {
  font-size: 0.8em;
  width: 33.3%;
}

.elemsInRow_4 td {
  font-size: 0.6em;
  width: 25%;
}

.elemsInRow_5 td {
  font-size: 0.6em;
  width: 20%;
}

.elemsInRow_6 td {
  font-size: 0.5em;
  width: 16.6%;
}

.componentTitle {
  text-align: center;
}

.componentTitle > h2 {
  margin: 0px 0px 0.4em;
}

.titleLower {
  font-weight: normal;
}

.generatedQrComponent > img {
  max-width: 100%;
  min-width: 100%;
  height: auto;
  image-rendering: pixelated;
}

@media print {
  .containerHeader {
    display: none;
  }
  .generatedQrComponent {
    break-inside: avoid;
  }
  #global-message-container {
    display: none;
  }
  .base-view .panel {
    padding-bottom: 0px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */